@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

<ws-modal-wrapper headerLabel="Layout"
                  [excludeModalStyling]="true"
                  (save)="save()"
                  (cancel)="cancel()">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-lg-12">
                <div class="mb-3"
                     [ngClass]="{ 'has-error': form.controls.layoutName.touched && form.controls.layoutName.errors }">
                    <label for="layoutName">Name:</label>
                    <input type="text"
                           class="form-control"
                           id="layoutName"
                           placeholder="Name"
                           formControlName="layoutName"
                           autocomplete="off"/>
                    @if (form.controls.layoutName.touched && form.controls.layoutName.errors) {
                        <div class="error-feedback">
                            @if (form.controls.layoutName.errors.required) {
                                <div class="text-danger small">Name is required.</div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="mb-3"
                     [ngClass]="{ 'has-error': form.controls.description.touched && form.controls.description.errors }">
                    <label for="description">Description:</label>
                    <input type="text"
                           class="form-control"
                           placeholder="Description"
                           autocomplete="off"
                           formControlName="description"
                           maxlength="50"/>
                    @if (form.controls.description.touched && form.controls.description.errors) {
                        <div class="error-feedback">
                            @if (form.controls.description.errors.maxlength) {
                                <div class="text-danger small">Description max length is 50 characters.</div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="mb-3"
                     [ngClass]="{ 'has-error': form.controls.visibility.touched && form.controls.visibility.errors }">
                    <label for="visibility">Visibility:</label>
                    <span [popover]="visibilityTooltip"
                          placement="auto"
                          triggers="mouseenter:mouseleave"
                          class="ag-grid-layout-specification-details-visibility-tooltip">
                        <i class="fa fa-info-circle small"></i>
                    </span>
                    <select id="visibility"
                            class="form-select form-select-sm"
                            formControlName="visibility">
                        @for (v of params.visibilities; track v) {
                            <option [ngValue]="v">{{ v.name }}</option>
                        }
                    </select>
                    @if (form.controls.visibility.touched && form.controls.visibility.errors) {
                        <div class="error-feedback">
                            @if (form.controls.visibility.errors.required) {
                                <div class="text-danger small">Visibility is required.</div>
                            }
                        </div>
                    }
                    <div class="ag-grid-layout-specification-details-visibility-description small">
                        {{ params.companyId ? form.controls.visibility.value?.description : form.controls.visibility.value?.descriptionNoCompany }}
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div modal-footer class="d-flex">
        <div class="d-flex">
            @if (form.controls.visibility.value?.warning) {
                <div class="text-warning">
                    <span>
                        <i class="fa fa-warning"></i>
                    </span>
                    {{ form.controls.visibility.value?.warning }}
                </div>
            }
        </div>
        <div class="d-flex">
            <div class="mx-1" helpTooltip helpContentId="app.save">
                <button type="button" class="ace-btn btn-primary" (click)="save()" [disabled]="!form.valid">Save
                </button>
            </div>
            <div class="mx-1" helpTooltip helpContentId="app.cancel">
                <button type="button" class="ace-btn btn-secondary" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</ws-modal-wrapper>

<ng-template #visibilityTooltip>
    <div class="ws-flex-container-vertical">
        <ul class="ag-grid-layout-specification-details-visibility-list">
            @for (v of params.visibilities; track v) {
                <li>
                    <strong>{{ v.name }}</strong>: {{ params.companyId ? v.description : v.descriptionNoCompany }}
                </li>
            }
        </ul>
    </div>
</ng-template>
